import * as React from 'react';
import { BreadcrumbsContainer } from '../../Breadcrumbs';
import { StepsTileContainer } from '../../StepsTile';
import * as style from '../MainPage.css';
import { PictureVasya } from '../picture/vasya';
import { Questions } from '../../Questions';
import { IMainPageContent } from '../../../types/helper';
import { PictureBox } from '../picture/box';
import { PictureCat } from '../picture/cat';
import { clickAskProfessional } from '../../../utils/events';

interface IMainViewDesktop {
  content: IMainPageContent;
}

export const ViewDesktop = (props: IMainViewDesktop) => {
  // tslint:disable:max-line-length
  return (
  <React.Fragment>
    <div className={style['body']}>
      <div>
        <BreadcrumbsContainer />
        <div className={style['title']}>
          {props.content && props.content.title}
        </div>
        <div className={style['description']}>
          {props.content && props.content.body}
        </div>
      </div>
      <div className={style['picture']}>
        <PictureVasya />
      </div>
    </div>
    <div className={style['container']}>
      <StepsTileContainer />
      <Questions />
      <div className={style['footer_container']}>
        <div className={style['picture_box']}><PictureBox width={128} height={119} /></div>
        <div className={style['footer_body']}>
          <div className={style['footer_title']}>Не нашли нужной вам информации?</div>
          <a onClick={clickAskProfessional} href="https://www.cian.ru/add-vopros/">
            Спросите у профессионала
          </a>
          <br />
          или <a href="https://docs.google.com/forms/u/1/d/e/1FAIpQLSchgoXzaxnvx5obzuLB9cyucYPhha1KKvGsky-aX-TmZybndQ/viewform">оставьте отзыв о Помощнике</a>
        </div>
        <div className={style['picture_cat']}><PictureCat /></div>
      </div>
    </div>
  </React.Fragment>
  );
};
